import { Flex, Heading, Image, SimpleGrid, Box } from '@chakra-ui/react'
import { FC } from 'react'
import { useLocale } from '../../hooks/useLocale'
import {
  HUPO_CORE_ANDROID_PLAY_STORE_LINK,
  HUPO_CORE_IOS_APP_STORE_LINK,
} from '../../app/constants'

const AppDistribution: FC<any> = () => {
  const { t } = useLocale()
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      padding={10}
      direction="column"
    >
      <Heading
        display="inline-block"
        as="h5"
        size="lg"
        textAlign={'center'}
        mb={10}
      >
        {t('download-app-from-links')}
      </Heading>
      <SimpleGrid
        minChildWidth="220px"
        spacing="100px"
        style={{ alignItems: 'center' }}
      >
        <Box>
          <a href={HUPO_CORE_IOS_APP_STORE_LINK}>
            <Image
              src={'../../images/apple-app-store-logo.jpeg'}
              style={{ paddingLeft: 10, paddingRight: 10 }}
              objectFit={'cover'}
              alt={'iOS App Store Link'}
            />
          </a>
        </Box>
        <Box>
          <a href={HUPO_CORE_ANDROID_PLAY_STORE_LINK}>
            <Image
              src={'../../images/google-play-logo.jpeg'}
              style={{ paddingLeft: 10, paddingRight: 10 }}
              objectFit={'cover'}
              alt={'APK download link'}
            />
          </a>
        </Box>
      </SimpleGrid>
    </Flex>
  )
}

export default AppDistribution
